import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { CompanyUserRole } from '../enums/company-user.role.enum';
import { User } from '../interfaces/user';

@Injectable({
  providedIn: 'root',
})
export class UsersAdapter {
  private http = inject(HttpClient);

  getUsers(): Observable<any> {
    return this.http.get(`${environment.apiBaseUrl}/company/users`);
  }

  createUser(user: User): Observable<any> {
    return this.http.post(`${environment.apiBaseUrl}/company/users`, user);
  }

  editUser(userId: number, role: CompanyUserRole): Observable<any> {
    return this.http.patch(
      `${environment.apiBaseUrl}/company/users/${userId}`,
      { role: role }
    );
  }

  resendInvite(userID: number): Observable<any> {
    return this.http.patch(
      `${environment.apiBaseUrl}/company/users/${userID}/invite`,
      null
    );
  }

  resetPassword(userID: number): Observable<any> {
    return this.http.patch(
      `${environment.apiBaseUrl}/company/users/${userID}/reset`,
      null
    );
  }

  resetTFA(userID: number): Observable<any> {
    return this.http.patch(
      `${environment.apiBaseUrl}/company/users/${userID}/reset-2fa`,
      null
    );
  }

  deleteUser(user: User): Observable<any> {
    return this.http.delete(
      `${environment.apiBaseUrl}/company/users/${user.id}`
    );
  }
}
